import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useConfigStore } from '@/store';

export function Clock() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const timeFormat = useConfigStore((state) => state.timeFormat);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Convert AngularJS format to date-fns format
  const formatString = timeFormat === 'HH:mm' ? 'HH:mm' : 'hh:mm a';

  return (
    <span className="text-[1.8em] font-[IBM_Plex_Sans,Helvetica,Arial,sans-serif] leading-[2em] inline-block ml-12 mr-2 font-bold">
      {format(currentTime, formatString)}
    </span>
  );
}
